import React from 'react';
import EngineerNavbar from './EngineerNavbar';
import EngineerFooter from './EngineerFooter';

const EngineerLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="no-print">
                <EngineerNavbar />
            </div>
            <main className="flex-grow overflow-x-hidden">
                {children}
            </main>
            <div className="no-print">
                <EngineerFooter />
            </div>
        </div>
    );
};

export default EngineerLayout;
